import { Button, makeStyles } from '@material-ui/core';
import { ArrowBack } from '@material-ui/icons';
import React from 'react';
import { SwiperSlide } from 'swiper/react';


let responsiveLength = "1000";


let useSyles = makeStyles((theme) => ({
    root: {
        // marginTop: 50,
        ...theme.grid.gridMdContent,
        // maxWidth: '100%',
        margin: '50px auto',
        padding: '20px 0px',
        backgroundColor: '#F8F7FB',
        minHeight: 350,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 13,
        [theme.breakpoints.down('1500')]: {
            width: '90%',
        },
        [theme.breakpoints.down('1250')]: {
            // width: '95%',
        },
        [theme.breakpoints.down(responsiveLength)]: {
            minHeight: 525,
        },
        [theme.breakpoints.down('501')]: {
            width: '97%',
        }
    },
    grid: {
        width: '100%',
        margin: 'auto',
        position: 'relative',
        // color: '#ffffff',
        display: 'flex',
        justifyContent: 'space-around',
        flexDirection: 'row-reverse',
        alignItems: 'center',
        [theme.breakpoints.down('1135')]: {
            flexDirection: 'column-reverse',
        },
        [theme.breakpoints.down(responsiveLength)]: {
            flexDirection: 'column-reverse',
        }
    },
    gridImages: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        [theme.breakpoints.down(responsiveLength)]: {
            width: '100%',
            justifyContent: 'center',
            '& > img': {
                maxWidth: '100%',
                marginBottom: 10
            },
        }
    },
    desce: {
        margin: '20px 0px',
        width: 500,
        fontSize: 16,
        color: '#000000',
        [theme.breakpoints.down('1500')]: {
            fontSize: 16,
        },
        [theme.breakpoints.down('1250')]: {
            fontSize: 14,
        },
        [theme.breakpoints.down('500')]: {
            width: '90%',
            textAlign: 'justify',
            margin: '20px auto',
        }
    },
    title: {
        fontSize: 30,
        whiteSpace: 'nowrap',
        fontWeight: 700,
        [theme.breakpoints.down('1500')]: {
            fontSize: 26,
        },
        [theme.breakpoints.down('500')]: {
            whiteSpace: 'normal',
            width: '90%',
            margin: 'auto',
            textAlign: 'center'
        }
    },
    gridBtn: {
        width: '94%',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        marginTop: 10,
        [theme.breakpoints.down(responsiveLength)]: {
            // justifyContent: 'space-around',
        },
        [theme.breakpoints.down('500')]: {
            width: '100%',
          
        },
        [theme.breakpoints.down(500)]: {
            flexDirection: 'column',
            justifyContent: 'center',
            width: '90%',
            margin: 'auto'
        },
    },
    btnWhite: {
        padding: '0px 25px',
        fontSize: 16,
        [theme.breakpoints.down('500')]: {
            width: '90%',
            margin: 'auto',
            justifyContent: 'center',
        },
    },
    btnRed: {
        // width: '58%',
        backgroundColor: theme.palette.light.type2,
        color: "white !important",
        margin: "0px 5px 0px 0px",
        padding: '9px 20px',
        border: `1px solid ${theme.palette.light.type2}`,
        fontSize: 14,
        whiteSpace: 'nowrap',
        [theme.breakpoints.down("1236")]: {
            padding: '9px 31px',
        },
        [theme.breakpoints.down("500")]: {
           width: '90%',
           margin: "0px 0px 5px 0px",
        },

        '&:hover': {
            backgroundColor: "transparent",
            color: "#071b2c !important",
            border: `1px solid black `,
        },
    },
    line: {
        borderRadius: 3,
        height: 4,
        border: 'none',
        backgroundColor: theme.palette.light.type2,
        position: 'absolute',
        top: -10,
        width: 30,
        [theme.breakpoints.down('1135')]: {
            top: -10,
            display: 'none'
        },
        [theme.breakpoints.down(responsiveLength)]: {
            top: -10,
            display: 'none'
        }
    },
    gridIconRight: {
        width: 50,
        marginRight: 40,
        [theme.breakpoints.down(responsiveLength)]: {
            marginRight: 0,
            display: 'none',
        }
    },
    gridIconLeft: {
        width: 50,
        marginLeft: 0,
        transform: "rotate(180deg)",
        [theme.breakpoints.down(responsiveLength)]: {
            marginLeft: 0,
            display: 'none',
        }
    },
    icon: {
        width: 50,
    },
    gridContent: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        [theme.breakpoints.down(responsiveLength)]: {
            marginRight: 0,
            marginTop: 20,
            textAlign: 'center',
            width: '100%',
            justifyContent: 'center',
        }
    },
    bgBtn: {
        height: 40,
        width: 40,
        padding: 5,
        backgroundColor: '#132b41',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 9,
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: 'rgba(255,255,255,0.2)',
        }
    },
    gridIcons: {
        width: 13,
        height: 13,
        padding: 10,
        borderRadius: '50%',
        backgroundColor: '#49A629',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    cardList: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: 20,
        marginBottom: 15,
    },
    titleIcons: {
        marginBottom: 0,
        marginLeft: 10,
        fontWeight: 700,
        fontSize: 16,
    },
    gridCardList: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        [theme.breakpoints.down('500')]: {
            justifyContent: 'center',
            flexWrap: 'wrap',
            flexDirection: 'column',
        },
    },
    iconArrowLeft: {
        marginLeft: 10,
    }
}))

export default function Index({ data }) {

    let classes = useSyles();




    return (
        <div className={classes['root']}>
            <div className={classes['grid']}>
                <div style={{ position: 'relative' }}>
                    <div>
                        <div className={classes['line']} />
                        <h3 className={classes['title']}>
                            سبدگردانی
                        </h3>
                        <p className={classes['desce']} style={{ marginBottom: 5 }}>
                            سبدگردانی به سرمایه‌گذاران این امکان را می‌دهد تا با تشکیل یک سبد از چندین نوع سهام، ریسک سرمایه‌گذاری خود را کاهش دهند و از مزایای متنوعی از جمله رشد سهام و تقسیم سود بهره‌مند شوند.
                        </p>
                        <p className={classes['desce']} style={{ marginTop: 0 }}>
                            این استراتژی به سرمایه‌گذاران اطمینان می‌دهد که سرمایه‌گذاری‌هایشان با توجه به اهداف مالی و ریسک، به بهترین شکل مدیریت می‌شود.
                        </p>
                        <div className={classes['gridCardList']}>
                            <div className={classes['cardList']}>
                                <div className={classes['gridIcons']}>
                                    <img src='/assets/images/arrow_Left.png' alt='' />
                                </div>
                                <p className={classes['titleIcons']}>
                                    تنوع در سرمایه گذاری
                                </p>
                            </div>
                            <div className={classes['cardList']}>
                                <div className={classes['gridIcons']}>
                                    <img src='/assets/images/arrow_Left.png' alt='' />
                                </div>
                                <p className={classes['titleIcons']}>
                                    مدیریت بهتر ریسک
                                </p>
                            </div>
                        </div>
                        <div className={classes['gridCardList']}>
                            <div className={classes['cardList']}>
                                <div className={classes['gridIcons']}>
                                    <img src='/assets/images/arrow_Left.png' alt='' />
                                </div>
                                <p className={classes['titleIcons']}>
                                    بهره‌وری در مدیریت زمان
                                </p>
                            </div>

                        </div>
                        {/* <div className={classes['gridBtn']}>
                            <Button
                                className={classes.btnRed}
                                // href={'/deceased-people'}
                            >
                                شروع سبدگردانی
                            </Button>

                            <button type="" className={`${classes['btnWhite']} btnPouyanWhite`}>
                                اطلاعات بیشتر
                                <img src='/assets/images/VectorRight.png' alt='' className={classes['iconArrowLeft']} />
                            </button>
                        </div> */}
                    </div>
                    <div>

                    </div>
                </div>
                <div className={classes['gridImages']}>
                    <img src={'/assets/images/Group 59.png'} alt={data?.title} />
                </div>
            </div>
        </div >)
}
